<template>
	<div id="fuckupAbout">
		<section class="post">
			<p class="text-center mt-0">
				<img style="width:200px" class="logo_sofa_small" alt="Sofareisen Logo" src="/images/sofareisen_logo_all.png">
			</p>

			<header class="major mb-0">
				<h2>Verlosung - radzelten</h2>
			</header>
			<div style="text-align:center;margin:auto;width:500px;height:250px;">
				<img v-if="isChoosing" style="" src="/images/heart_animated.gif" height="100%"/>
				<h1 v-else-if="winnerList.length>0" class="text-center vertical-center" style="color:#78a14b;">
					<span style="font-size: small;color:grey;">Herzlichen Glückwunsch</span><br>
					<span>{{lastWinner.name}}</span><br>
					<div class="mt-2"><img style="max-height:100px;max-width:150px;" :src="lastWinner.img"></div>
					<div style="font-size: small;color:grey;">{{lastWinner.price}}</div>
				</h1>
				
			</div>
			<hr/>
			<h2 class="text-center mt-4">Unsere Gewinner:</h2>
			<h2 class="text-center mb-0" style="color:grey;height:150px"><div style="margin-right:1em;margin-left:1em" v-for="(winner,index) in winnerList" :key="index">{{winner.name}} <span v-if="winner.price"> ({{winner.price}})</span></div></h2>
			<p class="text-center mt-3">
				<a class="primary button" @click.prevent="picker"><i class='icon solid fa-lg fa-star mr-1'></i>Gewinner ziehen</a>
			</p>
		</section>
  </div>
</template>

<script>
import {helper} from '@/mixins/helper.js'
	export default {
		name: 'RandomView',
		mixins:[helper],
		components: {
	},
	data() {
		return {
			chosenName:"",
			prices:[
				{price:"Vinyl LP - Atlas Bird",img:"https://f4.bcbits.com/img/a4050328564_16.jpg"},
				{price:"Pamir Print",img:"https://www.radzelten.de/wp-content/uploads/2017/09/radzelten-2431-1.jpg"},
				{price:"Pamir Print",img:"https://www.radzelten.de/wp-content/uploads/2017/09/radzelten-2431-1.jpg"},
			],
			list:[""],
			winnerList:[],
			isChoosing:false,
		}
	},
	computed: {
		lastWinner(){
			return this._.last(this.winnerList)
		}
	},
	methods:{
		picker(){
			if(this.list.length>0){
				this.isChoosing=true;
				setTimeout(()=>{
					this.isChoosing=false;
					this.winnerList.push(this.getWinnerObject(this.chosenName,this.winnerList.length));
				},3000);
				let chosenNumber = Math.floor(Math.random() * this.list.length);
				this.chosenName = this.list[chosenNumber];
				this.list=this.list.filter((name)=>{
					return name!=this.chosenName ;
				})
			}
		},
		getWinnerObject(name,priceIndex){
			let priceObj=this.prices[priceIndex];
			let nameObj={name:name};
			return (priceObj)?this._.merge(nameObj,priceObj):nameObj;
		}
	},
  }
</script>

<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 30%;
  left:0;
  text-align: center;
  width:100%;
}
</style>
